import ReactDOM from 'react-dom';
import React, { useEffect, useState } from 'react';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Form from "react-bootstrap/Form";
import e from '../style.module.css';
import TableRender from 'components/common/TableRender/TableRender';
import apiService from 'Services/apiService';
import { SkeTable } from 'components/common/Skeleton/SkeTable';
import { DynamicRow } from 'Interface/generic.model';
import AlertNotification, {IAlert} from "components/common/AlertNotification/AlertNotification";
import { DownloadDOC } from 'Utils/Fn/DownloadDOC';
import { formatDate, formatSimpleDate } from 'Utils/Fn/DateParser';
import { phoneFilter } from 'Utils/Fn/PhoneParser';
import { currencyFilter } from 'Utils/Fn/currency';
import Search from "components/common/Search/Search";
import ModalReports from './ModalReport';
import ButtonComp from "components/common/Button/Button";

import './style.css'

function ModalPoliciesTabs({ show, mData, handleClose }: IModal) {
  const [fleetVehicle, setFleetVehicle] = useState<any[]>([]);
  const [filteredFleetVehicle, setFilteredFleetVehicle] = useState<any[]>([]);
  const [chasisFilter, setChasisFilter] = useState('');
  const [dateFilter, setDateFilter] = useState('');
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [showMReports, setShowMReports] = useState(false);

  const [excludedVehicles, setExcludedVehicles] = useState<{ [key: string]: boolean }>({});
  const [excludedVehicle, setExcludedVehicle] = useState<any[]>([]);
  const [policeInfo, setPoliceInfo] = useState<any>({});
  const [docsList, setDocsList] = useState<any[]>([]);

  const showFlotillaTabs= ['VEHICULOS DE MOTOR FLOTILLA', 'VEHICULO DE MOTOR'];

  const [loading, setLoading] = useState(true);
  const [loadingExcluded, setLoadingExcluded] = useState(true);
  const [loadingSwitch, setLoadingSwitch] = useState<{ [key: string]: boolean }>({});
  const [alert, setAlert] =  useState<IAlert>({ show: false, title: '', details: '', variant: 'Danger' });
  const [disableBtn, setDisableBtn] = useState<{ [key: string]: boolean }>({});
  const [disableDocsBtn, setDisableDocsBtn] = useState<{ [key: string]: boolean }>({});
  const [disableBtnExport] = useState<boolean>(false);

  const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
  const userTypes:any = {
    "Individual": "P",
    "Corporativa": "G",
    "Gobierno": "G",
    "Empresarial": "E"
  }

  const POLICIES_ROWS = [
    {label: 'Chasis', key: 'chasis'},
    {label: 'Marca', key: 'marca'},
    {label: 'Año', key: 'año'},
    {label: 'Modelo', key: 'modelo'},
    {label: 'Placa', key: 'placa'},
    {label: 'Conductor', key: 'conductor'}
  ]

  const ExcludeSwitch = (row: DynamicRow) => (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={`tooltip-exclude-${row.id}`}>Excluir vehículo</Tooltip>}
    >
      {
        loadingSwitch[row.id] ? (
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        ) : (
        <Form.Check 
          type="switch" 
          id={`exclude-switch-${row.id}`} 
          checked={excludedVehicles[row.id] || false} 
          onChange={() => toggleExcludeVehicle(row)}
          className='hover-pointer'
        />
        )
      }
    </OverlayTrigger>
  );

  const SLOT = {label: '', key: 'driveSlot', slotName: 'driveSlot'}
  const EXCLUDE_COLUMN = {label: '', key: 'excludeSlot', slotName: 'excludeSlot'};

  const DOCS_ROWS = [
    {label: 'Nombre Archivo', key: '_nombre'},
    {label: 'Size', key: '_size'},
    {label: 'Fecha ultima Modificación', key: 'update_date'},
    {label: '', key: 'docsSlot', slotName: 'docsSlot'}
  ]

  useEffect(() => {
    if (!show) return
    apiService({
      name: 'getPoliciesCopByCode',
      queryParams: { _codigoPoliza: mData?.codPoliza },
      onSuccess: ({response}) => {
        setPoliceInfo(response[0]);        
      },
      onError: (error) => {
        console.error('Error:', error);
        setAlert({
          show: true,
          title: `Error al obtener el detalle de póliza #${mData?.numPoliza}`,
          details: error,
          variant: 'Danger'
        })
      },
      onFinally() {
        setLoading(false);
      }
    });
    apiService({
      name: 'getArchivosFisicobyCodPol',
      queryParams: { _codigoPoliza : mData?.codPoliza},
      onSuccess: ({response}) => {
        const resp = response.map((data: any, i: any) => (
          {...data,
            idNew: data._id + i,
            update_date:formatDate(data._fecModificacion)
          }
        ));
        setDocsList(resp);       
      },
      onError: (error) => {
        console.error('Error:', error);
        setAlert({
          show: true,
          title: 'Error al obtener los documentos disponibles',
          details: error,
          variant: 'Danger'
        })
      },
      onFinally() {
        setLoading(false);
      }
    });
    if (showFlotillaTabs.includes(mData?.ramo)) {
      apiService({
        name: 'getFleetVehicleCop',
        queryParams: { _numeroPoliza: mData?.numPoliza },
        onSuccess: ({response}) => {
          const resp = response.map((data: any) => (
            {...data,
              id: data.chasis
            }
          ));
          setFleetVehicle(resp);
          setFilteredFleetVehicle(resp);
        },
        onError: (error) => {
          console.error('Error:', error);
          setAlert({
            show: true,
            title: 'Error al obtener los datos para flotilla de vehiculos',
            details: error,
            variant: 'Danger'
          })
        },
        onFinally() {
          setLoading(false);
        }
      });
      getExluded()
    }
  }, [show]);

  const resetAlert = () => {
    setAlert(prev => ({ ...prev, show: false }));
  };
  const getExluded = () => {
    apiService({
      name: 'getFleetExcludedVehicleCop',
      queryParams: { _numeroPoliza: mData?.numPoliza },
      onSuccess: ({response}) => {
        const resp = response.map((data: any) => (
          {...data,
            id: data.nroChasis,
            chasis: data.nroChasis,
            año: data.anio,
            placa: data.nroPlaca
          }
        ));
        setExcludedVehicle(resp);        
      },
      onError: (error) => {
        console.error('Error:', error);
        setAlert({
          show: true,
          title: 'Error al obtener los datos para flotilla de vehiculos',
          details: error,
          variant: 'Danger'
        })
      },
      onFinally() {
        setLoadingExcluded(false);
      }
    });
  };

  const driveSlotBtn = (row: DynamicRow) => {
    return (
      <button
        type="button"
        id={row.iD_Auto}
        className="btn btn-link primary-text"
        onClick={() => download(row)}
        data-bs-toggle="tooltip" data-bs-placement="top" title="Descargar marbete"
        disabled={disableBtn[row.iD_Auto]}
      >
        {
          !disableBtn[row.iD_Auto]
          ? (<i className="bi bi-inbox"></i>)
          : (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)
        }
        
      </button>
    );
  };

  const docsSlotIcon = (row: DynamicRow) => {
    return (
      <button
        type="button"
        id={row.idNew}
        className="btn btn-link primary-text"
        onClick={() => downloadDocs(row)}
        data-bs-toggle="tooltip" data-bs-placement="top" title="Descargar documento"
        disabled={disableDocsBtn[row.idNew]}
      >
        {
          !disableDocsBtn[row.idNew]
          ? (<i className="bi bi-file-text"></i>)
          : (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>)
        }
      </button>
    );
  };

  // Columnas dinamicas
  const NEW_COLUMNS = [
    { label: 'ID Auto', key: 'iD_auto' },
    { label: 'Nro Póliza', key: 'nrO_POLIZA' },
    // { label: 'Tiempo Cobertura', key: 'tiempoCobertura' },
    { label: 'Moneda', key: 'moneda' },
    { label: 'Estado', key: 'estado' },
    { label: 'Identificación', key: 'sg_identificacion' },
    { label: 'Valor Asegurado', key: 'valorAsegurado', checkValue: true, classBody: 'text-right' },
    // { label: 'Fecha Facturación', key: 'fechaFacturacion', formatDate: true },
    { label: 'Identificación 1', key: 'sg_identificacion1' },
    { label: 'Valor vehículo', key: 'sg_valorveh', checkValue: true, classBody: 'text-right' },
    { label: 'Tipo vehículo', key: 'sg_tipoveh' },
    { label: 'Teléfono', key: 'sg_telefono' },
    { label: 'Correo', key: 'sg_correo' },
    { label: 'Fecha Emisión', key: 'fecha_emision' },
    { label: 'Vigencia', key: 'sg_vigencia', formatDate: true },
    { label: 'Cobertura', key: 'sg_cobertura' },
    { label: 'Fianza Judicial', key: 'sg_fianza_judiacial', checkValue: true, classBody: 'text-right' },
    { label: 'Prima Pagada', key: 'sg_prima_pagada', checkValue: true, classBody: 'text-right' }
  ];
  // Uso en el componente
  const [filteredColumns, setFilteredColumns] = useState([...POLICIES_ROWS]);
  
  const filterValidColumns = (data: any[]) => {
    return NEW_COLUMNS.filter(column => {
      if (column.checkValue) {
        return data.some(item => item[column.key] !== null && item[column.key] !== undefined && item[column.key] > 0);
      }
      if (column.formatDate) {
        return data.some(item => item[column.key] !== null && item[column.key] !== undefined);
      }
      return data.some(item => item[column.key] !== null && item[column.key] !== undefined);
    });
  };
  
  // Actualizar la lista de columnas válidas
  useEffect(() => {
    if (fleetVehicle.length > 0) {
      const additionalColumns = filterValidColumns(fleetVehicle);
  

      // Aplicar formato de fecha a las columnas correspondientes
      const formattedData = fleetVehicle.map(vehicle => ({
        ...vehicle,
        fechaFacturacion: vehicle.fechaFacturacion ? formatDate(vehicle.fechaFacturacion) : null,
        sg_vigencia: vehicle.sg_vigencia ? formatDate(vehicle.sg_vigencia) : null,
        sg_prima_pagada: currencyFilter({value: vehicle?.sg_prima_pagada, decimals: 2, prefix: '$'}),
        valorAsegurado: currencyFilter({value: vehicle?.valorAsegurado, decimals: 2, prefix: '$'}),
        sg_valorveh: currencyFilter({value: vehicle?.sg_valorveh, decimals: 2, prefix: '$'}),
        sg_telefono: phoneFilter(vehicle?.sg_telefono),
      }));
  
      setShowDateFilter(formattedData.some(vehicle => vehicle.fecha_emision) || dateFilter !== '');
      const formattedDateFilter = dateFilter ? formatSimpleDate(dateFilter) : '';

      // setFilteredFleetVehicle(formattedData);
      setFilteredFleetVehicle(
        formattedData.filter(vehicle => 
          (!chasisFilter || vehicle.chasis.toLowerCase().includes(chasisFilter.toLowerCase())) &&
          (!dateFilter || vehicle.fecha_emision === formattedDateFilter)
        )
      );
      
      setFilteredColumns([...POLICIES_ROWS, ...additionalColumns]);
    }
  }, [chasisFilter, dateFilter, fleetVehicle]);


  
  // Descargar polizas
  const download = (data: any) => {
    setDisableBtn((prevDisableBtn) => ({ ...prevDisableBtn, [data.iD_Auto]: true }));
    apiService({
      name: 'downloadMarbete',
      queryParams: {
        _numeroChasis: data.chasis,
        _codigoCliente: JSON.parse(localStorage.getItem('cliCod') || 'null'),
        _tipoCliente: userTypes[storedUser?.user?._tipoUsuario],
        _codigoAuto: data.iD_Auto
      },
      onSuccess: (resp) => {
        DownloadDOC(resp, `${data.chasis}_${data.conductor}.pdf`)
      },
      onError: (error) => {
        setAlert({
          show: true,
          title: 'Error al intentar descarger el marbete',
          details: error,
          variant: 'Danger'
        })
      },
      onFinally() {
        setDisableBtn((prevDisableBtn) => ({ ...prevDisableBtn, [data.iD_Auto]: false }));
      }
    });
  };

  // Descargar polizas
  const downloadDocs = (data: any) => {
    setDisableDocsBtn((prevDisableBtn) => ({ ...prevDisableBtn, [data.idNew]: true }));
    apiService({
      name: 'downloadFhysicalFiles',
      queryParams: { _codigoPoliza: data._id , _nombreArchivo: data._completo  },
      onSuccess: (resp) => {
        DownloadDOC(resp, `${data._nombre}.pdf`)
      },
      onError: (error) => {
        setAlert({
          show: true,
          title: 'Error al intentar descarger el documento',
          details: error,
          variant: 'Danger'
        })
      },
      onFinally() {
        setDisableDocsBtn((prevDisableBtn) => ({ ...prevDisableBtn, [data.idNew]: false }));
      }
    });
  };

  //filtrar por chasis
  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setChasisFilter(value);
    setFilteredFleetVehicle(
      fleetVehicle.filter(vehicle => 
        vehicle.chasis.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const handleDateFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDateFilter(e.target.value);
  };
  
  const toggleExcludeVehicle = (data: any) => {
    setLoadingSwitch((prevDisableBtn) => ({ ...prevDisableBtn, [data.id]: true }));

    apiService({
      name: 'putFlotillaStatus',
      queryParams: { 
        idAuto: data.iD_Auto,
        NoChasis: data.chasis
      },
      onSuccess: () => {
        setAlert({
          show: true,
          title: 'Éxito',
          details: `Vehículo ${data.iD_Auto} excluido exitosamente`,
          variant: 'Success'
        });
        setFleetVehicle(prev => prev.filter(vehicle => vehicle.chasis !== data.chasis));
        setFilteredFleetVehicle(prev => prev.filter(vehicle => vehicle.chasis !== data.chasis));
        getExluded();
      },
      onError: (error) => {
        console.error(`Error al excluir vehículo ${data.iD_Auto}:`, error);
        setAlert({
          show: true,
          title: `Error al excluir vehículo ${data.iD_Auto}:`,
          details: error,
          variant: 'Danger'
        })
      },
      onFinally() {
        setLoadingSwitch((prevDisableBtn) => ({ ...prevDisableBtn, [data.id]: false }));
      }
    });
  };

  return (
    <>
    <Modal
      show={show}
      onHide={()=> {
        setLoading(true)
        setLoadingExcluded(true)
        setFleetVehicle([])
        setExcludedVehicle([])
        setDocsList([])
        resetAlert()
        handleClose()
        setPoliceInfo([])        
        setDateFilter('')
        setShowDateFilter(false)
        setExcludedVehicles({})
      }}
      dialogClassName="modal-xl"
      aria-labelledby="example-custom-modal-styling-title"
      className={e['modal-billing']}
    >
      
      <Modal.Header closeButton>
        <Modal.Title>
          <span className={e.modal_header}>Póliza <small>#{mData?.numPoliza}</small></span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={e.modal_body}>
        <section className={e.section_modal}>
          <Tabs
            id="tab-BillingList"
            className={`mb-3 ${e['tab-modal']}`}
          >
            <Tab eventKey="policeDetail" title="Detalle">
            <table className="detail-table">
              <tbody>
                <tr>
                  <td>Código Cliente:</td>
                  <td>{policeInfo?.codCliente}</td>
                  <td>Estado de póliza:</td>
                  <td>{policeInfo?.estatus}</td>
                </tr>
                <tr>
                  <td>Código de póliza:</td>
                  <td>{policeInfo?.codPoliza}</td>
                  <td>Moneda:</td>
                  <td>{policeInfo?.moneda}</td>
                </tr>
                <tr>
                  <td>Aseguradora:</td>
                  <td>{policeInfo?.nomAseguradora}</td>
                  <td>Programa banca seguro:</td>
                  <td>{policeInfo?.sg_pz_bancaseguro ? 'SÍ' : 'NO'}</td>
                </tr>
                <tr>
                  <td>Ramo:</td>
                  <td>{policeInfo?.nomRamos}</td>
                  <td>Fecha ingreso a la póliza:</td>
                  <td>{formatDate(policeInfo?.fecIngreso)}</td>
                </tr>
                <tr>
                  <td>Prima:</td>
                  <td>{currencyFilter({value: policeInfo?.montoPrima, decimals: 2, prefix: '$'})}</td>
                  <td>Fin vigencia de la póliza:</td>
                  <td>{formatDate(policeInfo?.fecVigencia)}</td>
                </tr>
                <tr>
                  <td>Periodo de renovación:</td>
                  <td>{policeInfo?.periodoRenovacion}</td>
                  <td>Asignado a:</td>
                  <td>{policeInfo?.nomGestor || '--'}</td>
                </tr>
                <tr>
                  <td>Coaseguro:</td>
                  <td>{policeInfo?.codCoAsegurado ? 'SÍ' : 'NO'}</td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <section>
              <h5 className='mt-4'>Documentos disponibles</h5>
              <TableRender
                tableClass="table-physical-docs"
                id="documentsTablePol"
                schema={DOCS_ROWS}
                rows={docsList}
                slots={{
                  'docsSlot': docsSlotIcon
                }}
              />
            </section>
            </Tab>
            { showFlotillaTabs.includes(mData?.ramo) ?
              <Tab eventKey="fleetVehicle" title="Flotilla vehículos">
                {loading ? (
                  <SkeTable
                    col={8}
                    row={5}
                    className="pt-1"
                  />
                ) : (
                  <React.Fragment key={mData?.doc_num}>
                    <div className={`${e['table-container']} flex flex-column policiesTable-styles`}>
                      <div>
                        <div className="d-flex justify-content-center justify-content-md-start justify-content-lg-end">
                          <ButtonComp type="button" onClick={() => setShowMReports(true)} disabled={disableBtnExport} showLoading={true} value="Exportar Flotillas" className="px-3 py-2 mt-2 mt-lg-0"/>
                        </div>
                      </div>
                      <div className="row mb-3 px-3 p-md-1">
                        <div className="col-md-4">
                          <Search
                            onChange={handleFilterChange}
                            label="Filtrar por num. chasis"
                            placeholder="Num. chasis"
                          />
                        </div>
                        {showDateFilter && (
                          <div className="col-md-4">
                            <label>Filtrar por fecha de emisión</label>
                            <input
                              type="date"
                              className="form-control"
                              max={new Date().toISOString().split('T')[0]}
                              value={dateFilter}
                              onChange={handleDateFilterChange}
                            />
                          </div>
                        )}
                      </div>
                        <TableRender
                          id="PoliciesTable"
                          schema={[SLOT, EXCLUDE_COLUMN, ...filteredColumns]}
                          rows={filteredFleetVehicle}
                          slots={{
                            'excludeSlot': ExcludeSwitch,
                            'driveSlot': driveSlotBtn
                          }}
                        />
                    </div>
                </React.Fragment>
                )}            
              </Tab>
            : null}
            { showFlotillaTabs.includes(mData?.ramo) ?
              <Tab eventKey="vehicleExcluded" title="Vehículos excluidos">
                {loadingExcluded ? (
                  <SkeTable
                    col={8}
                    row={5}
                    className="pt-1"
                  />
                ) : (
                  <React.Fragment key={mData?.numPoliza}>
                    <div className={e['table-container']}>
                      <TableRender
                        id="vehicleExcludedTable"
                        schema={POLICIES_ROWS}
                        rows={excludedVehicle}
                        slots={{
                          'driveSlot': driveSlotBtn
                        }}
                      />
                    </div>
                </React.Fragment>
                )}
              </Tab>
            : null} 
          </Tabs>
        </section>     
      </Modal.Body>

      <Modal.Footer>
        <Button variant='secondary' onClick={() => {
          setLoading(true)
          setLoadingExcluded(true)
          setFleetVehicle([])
          setFilteredFleetVehicle([])
          setExcludedVehicle([])
          setPoliceInfo([])
          setDocsList([])
          resetAlert()
          handleClose()
        }}>
          Close
        </Button>
      </Modal.Footer>
      <AlertNotification
          show={alert?.show}
          title= {alert?.title}
          details= {alert?.details}
          variant={alert?.variant}
          onClose={resetAlert}
      />
      <ModalReports  show={showMReports} handleClose={() => setShowMReports(false)} mData={{name: 'downloadExcelFlotillasByDate', docName: 'Poliza', docExt: 'xlsx', numPol: mData?.numPoliza}}/>

    </Modal>
  </>
  )
}


export default function ModalPolicies ({ show, handleClose, mData }: IModal) {

  const modalRoot = document.getElementById('modal-root') as HTMLElement;

  return ReactDOM.createPortal(
  <ModalPoliciesTabs
    show={show} 
    handleClose={handleClose} 
    mData={mData} 
  />, 
  modalRoot)

}


interface IModal{
  show: boolean;
  mData: any;
  handleClose: () => void;
}